import { render, staticRenderFns } from "./quota-settings-modal.vue?vue&type=template&id=cf8be1be"
import script from "./quota-settings-modal.vue?vue&type=script&lang=js"
export * from "./quota-settings-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports